{
  "close": "Aizvērt",
  "notifications": "{count, plural, one {# paziņojums} other {# paziņojumi}}."
}
